module.exports = __webpack_public_path__ + "static/media/thumbnail.6912e246.jpg";